import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { CorpDataNode, Corporation, CorpTreeItem } from './corporation.modal'

export function loadCorpTree(): Promise<CorpTreeItem[]> {
	return request.get(ApiAddress.CORP_TREE)
}

export function loadCorporation() {
	return request.get<any, Corporation>(ApiAddress.CORP).then(res => {
		return res
	})
}

export function updateCorporation(data: Corporation) {
	return request.put(ApiAddress.CORP, data)
}

export function listToTree(list: CorpTreeItem[] = [], parent: string | number = 0) {
	// 边界条件检查
	if (!list || list.length === 0) return []

	// 创建节点映射和根节点数组
	const nodeMap = new Map<string | number, CorpDataNode>()
	const roots: CorpDataNode[] = []

	// 预先创建所有节点
	for (let i = 0, len = list.length; i < len; i++) {
		const item = list[i]
		nodeMap.set(item.id, {
			...item,
			title: item.name,
			key: item.id,
			children: []
		})
	}

	// 建立父子关系
	for (let i = 0, len = list.length; i < len; i++) {
		const item = list[i]
		const node = nodeMap.get(item.id)!

		if (item.pid === parent) {
			roots.push(node)
		} else {
			const parentNode = nodeMap.get(item.pid)
			if (parentNode) {
				parentNode.children?.push(node)
			}
		}
	}

	return roots
}

export function filterTree(tree: CorpDataNode[], text: string | undefined) {
	if (!text) {
		return tree
	}

	const getNodes = (result: CorpDataNode[], object: any) => {
		if (object.name.toLowerCase().includes(text.toLowerCase())) {
			result.push(object)
			return result
		}
		if (Array.isArray(object.children)) {
			const children = object.children.reduce(getNodes, [])
			if (children.length) result.push({ ...object, children })
		}
		return result
	}

	return tree.reduce(getNodes, [])
}
